import { ServiceSchedule } from "./schedule"

export interface Quotation {
    id?: number;
    code?: string;
    datetime: string;
    total: number
    customerId?: number
    customerName: string
    customerPhone?: string
    customerEmail?: string
    customerNit?: string
    customerAddress?: string
    detail: QuotationDetail[]
    status: QuotationtStatus
    documentType?: QuotationDocumentType
    policies: QuotationPolicy[]
    name: string
    contact: string
    expirationDays: number
    address: string
    template?: QuotationTemplate
    lastQuotationTemplateId?: number
    lastProposalTemplateId?: number
    proposalShowPrices?: boolean
    proposalCoverCategoryMode?: ProposalCoverCategoryMode
    proposalCoverCategoryIds?: number[]
}

export interface QuotationDetail {
    id?: number
    qty: number
    description: string
    price: number
    total: number
    ref?: string
    characteristics: string[]
    service?: number
    serviceId?: number
    serviceName?: string
    serviceCategory?: string
    longDescription?: string
    benefits?: string[]
    imageUrl?: string
    schedules?: ServiceSchedule[]
}

export interface QuotationPolicy {
    id?: number
    name: string
    description: string
    ref?: string
}

export enum QuotationtStatus {
    DRAFT = 'DRAFT',
    SENT = 'SENT',
    APPROVED = 'APPROVED',
    REJECTED = 'REJECTED',
    DELETED = 'DELETED',
}

export enum QuotationDocumentType {
    QUOTATION = "QUOTATION",
    PROPOSAL = "PROPOSAL",
}

export enum ProposalCoverCategoryMode {
    NONE = "NONE",
    ALL = "ALL",
    SELECTED = "SELECTED",
}

export interface QuotationTemplate {
    id?: number
    name: string
    description?: string
    type: QuotationTemplateType
    htmlTemplate: string
    htmlDetailTemplate?: string
    htmlPolicyTemplate?: string
    defaultData?: {
        salutation?: string
        body?: string
        close?: string
        brandName?: string
        brandPhone?: string
        brandWebsite?: string
    }
    backgroundImageUrl?: string
    isActive: boolean
}

export enum QuotationTemplateType {
    QUOTATION = "QUOTATION",
    PROPOSAL = "PROPOSAL",
}

export interface QuotationPdfRequest {
    templateId: number
    showPrices?: boolean
    messageCaption?: string
}
